import {createStore, applyMiddleware} from "redux";
import rootReducer from '../reducers';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import Raven from 'raven-js';
import createRavenMiddleware from "raven-for-redux";
import ignoreMutationStates from "./ignoreMutationStates";

Raven.config(
    SENTRY_DNS,
    {
        headers: {'x-sentry-token': X_SENTRY_TOKEN},
        shouldSendCallback: () => environment !== 'dev'
    })
    .install();

export default function configureStore(initialState) {
    // createRavenMiddleware(Raven);
    const middlewares = [thunk];
    if(environment === 'dev') {
        middlewares.push(reduxImmutableStateInvariant({ignore: ignoreMutationStates}));
    }

    return createStore(
        rootReducer,
        initialState,
        composeWithDevTools(applyMiddleware(...middlewares)),
    );
}


// WEBPACK FOOTER //
// ./web/src/store/configureStore.js